
import './applicationTableMaritalInfo.scss' 


const  ApplicationTableMaritalInfo = ({ applicationData, children}) => {

  
  return (
            
    <div className='item'>
       
        <div className="details">

        
          {/* <h3 className='itemTitle'>{applicationData.firstname} {applicationData.surname}</h3> */}
          <div className='detailItem'>
            <span className='itemKey'>Spouse Name:</span>
            <span className='itemValue'>{applicationData.spouseName}</span>
          </div>
          <div className='detailItem'>
            <span className='itemKey'>Spouse Date of Birth:</span>
            <span className='itemValue'>{applicationData.spouseDob}</span>
          </div>
         
{/* 
          <div className='detailItem'>
            <span className='itemKey'>Children:</span>
            {children === null
              ? 
            <span className='itemValue'> No children</span>
            :
            <span className='itemValue'>Has Children</span>
             }
           
          </div> */}


          {children
              
          ? 

          <div className='detailItem'>

            <span style={{fontWeight:'bold', color:'black', fontSize:18}}>Children Information:</span>
     
          </div>

          :

            "No Children"

          }

         
            {children !== null &&
            
            
            children?.map(child => (
            <div key={child.id} className='detailItem'>

              <div className='detailItem'>
              <span className='itemKey'>Child Name:</span>
              <span className='itemValue'>{child.firstname}</span>
              </div>
              <div className='detailItem'>
              <span className='itemKey'>Child DOB:</span>
              <span className='itemValue'>{child.birthDay}</span>
              </div>
              </div>

            ))
            }
        
      
        </div>
    </div>
   
  );
}

export default ApplicationTableMaritalInfo